import React from "react";
import { useCurrentRefinements } from "react-instantsearch-hooks";

// finds a list of refinements that are currently applied to search for the
// given attribute, used later to remove them when filter is changed
export const useAlgoliaRefinements = (attribute: string) => {
    const { items } = useCurrentRefinements();

    return React.useMemo(() => {
        return items
            .filter((refinement) => refinement.attribute === attribute)
            .map((refinement) => refinement.refinements)
            .reduce((prev, curr) => [...prev, ...curr], [])
            .map(({ value }) => value);
    }, [items, attribute]);
};
